// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"frsXK1p_vJgkQi_20zjE"};